import { StreamTypes } from 'store/player/actions.types';

import { VideoItem } from 'services/data-manager/types';

export type StartoverStreamType = 'static' | 'dynamic';

export type PlayerError = {
    code?: number | null | string;
    message?: string;
    description?: string;
    withIcon?: boolean;
};

export type SwitchPlayerSource = (
    videoItem?: VideoItem,
    playbackType?: StreamTypes,
) => void;

export enum RecordingType {
    PLAYER = 'PLAYER',
    DETAIL = 'DETAIL',
}

export type PlaybackStopParams = {
    resetSource?: boolean;
    resetPauseState?: boolean;
};
